"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      email: "",
      password: "",
      isLoading: false,
      sid: null,
      error: false,
      interval: null,
      errorMessage: null,
      url: "/login-email",
      formStep: 1,
      confirmationCode: null,
      twoFactorWay: null
    };
  },


  computed: {
    twoFactorWays: function twoFactorWays() {
      return [{
        id: "email",
        name: this.$t("login.placeholders.two_factor_email")
      }, {
        id: "sms",
        name: this.$t("login.placeholders.two_factor_sms")
      }];
    }
  },

  created: function created() {
    var twoFactorWays = this.twoFactorWays;
    this.twoFactorWay = twoFactorWays[0].id;
  },


  methods: {
    setEmail: function setEmail(email) {
      this.email = email;
    },
    setPassword: function setPassword(password) {
      this.password = password;
    },
    setTwoFactorWay: function setTwoFactorWay(twoFactorWay) {
      this.twoFactorWay = twoFactorWay.id;
    },
    setConfirmationCode: function setConfirmationCode(confirmationCode) {
      this.confirmationCode = confirmationCode;
    },
    authenticate: function authenticate() {
      if (this.isLoading) {
        return;
      }

      this.errorMessage = null;
      this.error = false;
      this.isLoading = true;
      this.startSigning();
      this.startAuthCheck();
    },
    startSigning: function startSigning() {
      var _this = this;

      var vm = this;

      axios.post(this.url, {
        email: this.email,
        password: this.password,
        confirmationCode: this.confirmationCode,
        locale: this.$i18n.locale,
        twoFactorWay: this.twoFactorWay
      }).then(function (res) {
        if (_this.formStep === 1) {
          _this.isLoading = false;
          vm.formStep = 2;
          vm.url = "/confirm-login-email";
          vm.error = false; // cheat
        }

        vm.sid = res.data.sid;
      }).catch(function (error) {
        _this.isLoading = false;
        _this.handleError(error);
      });
    },
    startAuthCheck: function startAuthCheck() {
      var vm = this;
      this.isLoading = true;
      if (vm.formStep === 2) {
        vm.interval = window.setInterval(function () {
          vm.checkIfAuthenticated();
        }, 3000);
      }
    },
    handleError: function handleError(error) {
      clearInterval(this.interval);
      this.isLoading = false;
      this.error = true;
      this.errorMessage = _.get(error.response.data, "data.email.0", error.response.data.message);
    },
    checkIfAuthenticated: function checkIfAuthenticated() {
      var _this2 = this;

      var vm = this;
      this.isLoading = true;
      axios.post("/auth/isauthenticated", {
        sid: this.sid,
        locale: this.$i18n.locale
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.status == "ok") {
          clearInterval(vm.interval);
          window.location.href = data.redirect;
        }
      }).catch(function (error) {
        _this2.isLoading = false;
        _this2.handleError(error);
      });
    },
    showForgotPassword: function showForgotPassword() {
      this.$emit("displayForgotPassword");
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/LoginFormEmail.vue
// module id = uaDN
// module chunks = 0 1